import { BuildingType, FloorType, AreaType } from "api/schema";
import { TimeSlot } from "shared/utils/date";
import { State, initialState, Action, ActionType } from "./definitions";

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionType.RESET: {
      return {
        ...initialState,
      };
    }
    case ActionType.SELECT_DATE: {
      return {
        ...state,
        selectedDate: action.payload as Date,
      };
    }
    case ActionType.SELECT_BUILDING: {
      return {
        ...state,
        selectedBuilding: action.payload as BuildingType,
        floors: [],
        selectedFloor: undefined,
        telephoneBoxes: [],
        selectedTelephoneBox: undefined,
      };
    }
    case ActionType.SET_FLOORS: {
      const floors = action.payload as FloorType[];
      const selectedFloor = floors.find(
        (f) => f.id === state.selectedFloor?.id,
      );
      return {
        ...state,
        floors,
        selectedFloor,
        telephoneBoxes: [],
        selectedTelephoneBox: undefined,
      };
    }
    case ActionType.SELECT_FLOOR: {
      return {
        ...state,
        selectedFloor: action.payload as FloorType,
        telephoneBoxes: [],
        selectedTelephoneBox: undefined,
      };
    }
    case ActionType.SET_TELEPHONE_BOXES: {
      const telephoneBoxes = action.payload as AreaType[];
      const selectedTelephoneBox = telephoneBoxes.find(
        (r) => r.id === state.selectedTelephoneBox?.id,
      );
      return {
        ...state,
        telephoneBoxes,
        selectedTelephoneBox,
      };
    }
    case ActionType.SELECT_TELEPHONE_BOX: {
      return {
        ...state,
        selectedTelephoneBox: action.payload as AreaType,
      };
    }
    case ActionType.SET_UNAVAILABLE_SLOTS: {
      return {
        ...state,
        unavailableSlots: action.payload as number[],
      };
    }
    case ActionType.SET_HOURS_RANGE: {
      const [start, end] = action.payload as TimeSlot;
      return {
        ...state,
        hoursStart: start,
        hoursEnd: end,
      };
    }
    default:
      throw new Error("Unknown action");
  }
}
